document.addEventListener('DOMContentLoaded', function () {
  const totalAthleteBlocks = document.querySelectorAll('.pm-8153-athletes-item').length;
  const swiperWrapper = document.querySelector('.swiper-container');

  const isLargeScreen = () => window.innerWidth >= 1024;
  const shouldInitSlider = () => !isLargeScreen() || totalAthleteBlocks >= 5;

  let mySwiper;

  function initSwiper() {
    if (!shouldInitSlider()) return;

    mySwiper = new Swiper('.pm-8153-athletes-slider-container', {
      loop: false,
      grabCursor: false,
      pagination: {
        el: '.pm-0002-athletes-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.pm-8153-athletes-arrow-right',
        prevEl: '.pm-8153-athletes-arrow-left',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 8,
        },
        600: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      on: {
        init: function () {
          this.emit('breakpoint');
        },
        breakpoint: function () {
          const navNext = document.querySelector('.pm-8153-athletes-arrow-right');
          const navPrev = document.querySelector('.pm-8153-athletes-arrow-left');
          const paginationEl = document.querySelector('.pm-0002-athletes-pagination');

          const showNav = totalAthleteBlocks >= 5 && isLargeScreen();
          if (navNext) navNext.style.display = showNav ? 'flex' : 'none';
          if (navPrev) navPrev.style.display = showNav ? 'flex' : 'none';
          if (paginationEl) paginationEl.style.display = showNav ? 'block' : 'none';
        },
      },
    });
  }

  function destroySwiper() {
    if (mySwiper) {
      mySwiper.destroy(true, true);
      mySwiper = null;
    }
  }

  function handleResize() {
    if (shouldInitSlider()) {
      if (!mySwiper) initSwiper();
    } else {
      destroySwiper();
    }
  }

  //initSwiper();
  handleResize();
  window.addEventListener('resize', handleResize);
});